import React from 'react';
import { OPERATOR } from '../../legal/operator';

export default function LegalFooter() {
  return (
    <footer style={s.footer}>
      © {new Date().getFullYear()} {OPERATOR.productName}
    </footer>
  );
}

const s = {
  // Footer mirrors the navbar exactly — same background + text colour in both
  // themes (purple in light, dark translucent in dark) for visual symmetry.
  footer: {
    borderTop: '1px solid var(--border)',
    background: 'var(--header-bg)',
    backdropFilter: 'var(--blur)',
    WebkitBackdropFilter: 'var(--blur)',
    padding: '14px 24px',
    color: 'var(--header-text)',
    fontSize: '13px',
    textAlign: 'center',
  },
};
